<script setup lang="ts">
import CatalogFiltersContainer from '~/layers/catalog/components/filter/CatalogFiltersContainer.vue'
import { useCatalogGridStore } from '~/layers/catalog/store/catalogGrid'
import type { TFilterItem } from '~/layers/catalog/data/types'

const gridStore = useCatalogGridStore()
const { reset } = useCatalogFilter()
</script>

<template>
  <div class="filters">
    <div class="filters__menu">
      <CatalogFiltersContainer :filters="gridStore.filters">
        <template #posieBanner>
          <PosieMiniBanner/>
        </template>
      </CatalogFiltersContainer>

      <div class="filters__buttons">
        <button class="filters__button filters__button_secondary" @click="reset">Сбросить всё</button>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@use '/assets/scss/components/filters.scss' as *;
</style>
